import {
  calculateCellValue, getDepositAmount, getDiscountSubTotalPrice,
  shouldUseMultipleWorkSheets,
  someDiscountIsCashAndSelected,
  someDiscountIsSubTotalAndSelected
} from "./discountFunctions";
import {getQuotePriceWithTaxes, getTotalPrice, toFixedPrice} from "../../misc/helpers";
import {DISCOUNT_MAIN_TYPES, DISCOUNT_TYPES} from "./discounstInterface";

export const getActiveDiscountFinanceAmount = (store) => {

  const fabricatorData = store.fabricatorState;
  const {financeActiveDiscount, discountSections, workSheetsCount, customAddedDiscounts} = store.priceWorksheetState;

  const {activeQuoteIndex} = store.quotesState;
  const fabricatorSettings = fabricatorData.settings;

  const hasMultipleWorkSheets = shouldUseMultipleWorkSheets(workSheetsCount);

  const totalPrice = hasMultipleWorkSheets ? getTotalPrice(activeQuoteIndex) : getTotalPrice();
  const grandTotal = getQuotePriceWithTaxes(totalPrice, discountSections);

  const cellsAreDisabled = fabricatorData.isAmericanStandard
    && (someDiscountIsCashAndSelected(customAddedDiscounts, discountSections)
      || !someDiscountIsSubTotalAndSelected(
        discountSections, activeQuoteIndex, hasMultipleWorkSheets
      ));
  return calculateCellValue(
    {
      discountSections,
      financePercentage: financeActiveDiscount ? financeActiveDiscount.financePercentage : 0,
      fabricatorSettings,
    },
    financeActiveDiscount ? financeActiveDiscount.financeMonths : 0,
    grandTotal,
    activeQuoteIndex,
    hasMultipleWorkSheets,
    cellsAreDisabled,
  )
}

/**
 * @param discountSections {discountSectionsInterface[]}
 * @param discountType {string}
 * @returns {{neededDiscount: discountInterface, neededDiscountSection: discountSectionsInterface}}
 * */
export const getSpecificDiscount = (discountSections, discountType) => {
  let neededDiscount = null;
  let neededDiscountSection = null;
  discountSections.forEach(sec => {
    if (neededDiscount) return;
    sec.discounts.forEach(discount => {
      if (neededDiscount) return;
      if (discount.discountType === discountType) {
        neededDiscount = discount;
        neededDiscountSection = sec;
      }
    })
  });
  return {neededDiscount, neededDiscountSection}
}


/**
 * @param store {object}
 * @param discount {discountInterface}
 * @returns {number}
 * */
export const getDownPaymentAmount = (store, discount) => {
  const {discountSections} = store.priceWorksheetState;
  if (!discountSections || !discountSections.length) {
    return 0;
  }
  if (!discount) {
    const {neededDiscount} = getSpecificDiscount(discountSections, DISCOUNT_MAIN_TYPES.downPayment);
    if (neededDiscount) {
      discount = neededDiscount;
    } else { // just in case
      return 0;
    }
  }
  if (discount.type === DISCOUNT_TYPES.percent) {
    const totalPrice = getTotalPrice();
    const grandTotal = getQuotePriceWithTaxes(totalPrice);
    return (grandTotal * discount.amount / 100) || 0 // percent from total
  }
  return discount.amount || 0
}

/**
 * @param store {object}
 * @param discountSection {discountSectionsInterface}
 * @param discount {discountInterface}
 * @returns {number}
 * */
export const getBalanceDueAmount = (store, discountSection = null, discount = null) => {

  if (!discountSection || !discount) {
    const {neededDiscount, neededDiscountSection} = getSpecificDiscount(store.priceWorksheetState.discountSections, DISCOUNT_MAIN_TYPES.balanceDue);
    if (neededDiscount) {
      discount = neededDiscount;
      discountSection = neededDiscountSection;
    } else { // just in case
      return 0;
    }
  }

  const {discountSections, customAddedDiscounts, workSheetsCount, financeActiveDiscount} = store.priceWorksheetState;
  // const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex} = store.quotesState;
  const fabricatorData = store.fabricatorState;

  const hasMultipleWorkSheets = shouldUseMultipleWorkSheets(workSheetsCount);

  const totalPrice = hasMultipleWorkSheets ? getTotalPrice(activeQuoteIndex) : getTotalPrice();
  const grandTotal = getQuotePriceWithTaxes(totalPrice, discountSections);

  const depositAmount = getDepositAmount(discountSections, grandTotal, fabricatorData) || 0;

  const {discountSubTotalWithTaxes} = getDiscountSubTotalPrice(
    discountSections,
    discountSection,
    discount,
    false,
    customAddedDiscounts,
    activeQuoteIndex,
    hasMultipleWorkSheets,
  );

  const downPaymentAmount = financeActiveDiscount ? getDownPaymentAmount(store) : 0;
  const balanceDueValue = +discountSubTotalWithTaxes - depositAmount - downPaymentAmount;

  return +toFixedPrice(balanceDueValue);
}
